"use strict";

exports.__esModule = true;
exports.getFilteredUserList = getFilteredUserList;
var _User = require("../Auth/User");
/**
 * Filter the given list of users using the given value filter term
 */
function getFilteredUserList(users) {
  return Object.values(users.users).filter(function (user) {
    if (user.isEnabled !== users.showEnabled) {
      return false;
    }
    var name = (0, _User.getUserName)(user);
    var searchableTerm = name + " " + user.username + " " + (user.profile ? user.profile.email : "");
    return searchableTerm.toUpperCase().includes(users.filterValue.toUpperCase());
  });
}